import axios from 'axios';
import jsonwebtoken from 'jsonwebtoken';

import {
  AUTH_FAIL,
  AUTH_SUCCESS
} from '../actions/authActions';

const initialState = {
  authenticated: false,
  jwt: null,
  username: null,
  adopter: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTH_FAIL: return onAuthFail(state, action);
    case AUTH_SUCCESS: return onAuthSuccess(state, action);
    default:
      return state;
  }
}

const onAuthFail = (state, action) => {
  console.log(action);
  localStorage.removeItem('jwt');
  localStorage.removeItem('blog');
  delete axios.defaults.headers.common['Authorization'];
  return { ...state, authenticated: false, jwt: null, username: null };
}

const onAuthSuccess = (state, action) => {

  localStorage.setItem('jwt', action.jwt);
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + action.jwt;

  return {
    ...state,
    authenticated: true,
    jwt: action.jwt,
    username: jsonwebtoken.decode(action.jwt).data.username,
    adopter: jsonwebtoken.decode(action.jwt).data.adopter,
    imported: jsonwebtoken.decode(action.jwt).data.imported,
  };
}